import axios from "axios";
import { API } from "@/lib/api";

let loadingScript;
const loadRazorpay = () => {
  if (window.Razorpay) return Promise.resolve();
  if (!loadingScript) loadingScript = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = resolve;
    script.onerror = () => { script.remove(); loadingScript = null; reject(new Error("Payment checkout could not load")); };
    document.body.appendChild(script);
  });
  return loadingScript;
};

export const openRazorpay = async (order, onVerified, onError) => {
  await loadRazorpay();
  const { data } = await axios.post(`${API}/payments/razorpay/order`, { order_id: order.order_id });
  const checkout = new window.Razorpay({
    key: data.key_id, amount: data.amount, currency: data.currency, order_id: data.razorpay_order_id,
    name: "Kandula Home Foods", description: `Order ${data.order_number}`, image: "/icons/icon-192.png",
    prefill: { name: order.customer?.name || "", contact: order.customer?.phone || "" }, theme: { color: "#2D4A3E" },
    handler: async (result) => {
      try { await axios.post(`${API}/payments/razorpay/verify`, { order_id: order.order_id, ...result }); onVerified(); }
      catch { onError("We couldn't verify the payment. Please contact us on WhatsApp."); }
    },
  });
  checkout.on("payment.failed", () => onError("Payment failed or cancelled. You can retry or pay via UPI."));
  checkout.open();
};